import React from 'react';
import { Button, Select } from 'antd';

import * as themes from '../../styles/themes';
import { changePrimaryThemeColour } from '../../helpers';

const initialClient = 'yuhu';
const listOfThemeNames = Object.keys(themes);

const ThemeSelect = ({ currentClient, changeClientTheme }) => {
  return (
    <>
      <Select
        style={{ width: 100 }}
        value={currentClient}
        onChange={(newTheme) => changeClientTheme(newTheme)}
      >
        {listOfThemeNames.map((themeKey) => (
          <Select.Option key={themeKey} value={themeKey}>
            {themeKey}
          </Select.Option>
        ))}
      </Select>
    </>
  );
};

const ClientThemeSelect = () => {
  const [currentClient, setCurrentClient] = React.useState(initialClient);

  const changeClientTheme = (newClientKey) => {
    setCurrentClient(newClientKey);
    const newPrimaryColour = themes[newClientKey]['@primary-color'];
    changePrimaryThemeColour(newPrimaryColour);
  };

  return (
    <>
      <ThemeSelect currentClient={currentClient} changeClientTheme={changeClientTheme} />
      <Button type="primary" loading>
        Button
      </Button>
    </>
  );
};

export default ClientThemeSelect;
